import React from 'react'
import Configurator from '../../../../configurator'
import {
    i18nWrapper,
    withRouterConnectWrapper,
} from '../../../../validator'
import Loader from '../loader'

import SportVenueBox from './box'
import { fetchTypesDetail } from './fetch-sportvenues'

/**
 * Render box with sport venue
 * If sport venue not exists, component will try download content by sport venue slug
 */
class PreloaderBox extends Configurator {
    /**
     * On mount
     */
    componentDidMount() {
        const {
            sportVenueSlug,
            sportVenueType,
        } = this.props

        if (sportVenueSlug) {
            fetchTypesDetail(sportVenueSlug, sportVenueType)
        }
    }

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const {
            busy,
            sportVenue,
            t,
        } = this.props

        if (busy) {
            return <Loader />
        }

        if (!sportVenue) {
            return t('sportFacilityBox.notFound.title')
        }

        return (
            <SportVenueBox {...this.props} sportVenue={sportVenue} />
        )
    }
}

export default withRouterConnectWrapper((state, ownProps) => ({
    sportVenue: ownProps.sportVenue || state.sportVenuesFront.types?.[ownProps?.sportVenueType]?.activeMarkerVenue,
    busy: ownProps.sportVenue ? false : state.sportVenuesFront.types?.[ownProps?.sportVenueType]?.busy,
}))(i18nWrapper(PreloaderBox))
